import Color from '../Color.mjs'
import superMeta from '../_COMMON/metaCommonNode.mjs'

export default {
    ...superMeta,
    themeColor: Color.GOLD,
    name: '场景',
    type: 'SCENE',
}
